function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import * as yup from 'yup';
import { LinkedTextInput } from '../TextInput';
import DialogForm from '../DialogForm';
import GridContainer from '../GridContainer';

const DeleteDialog = ({
  children,
  onClose,
  onDelete,
  open,
  ...props
}) => React.createElement(DialogForm, _extends({
  cancelButtonText: "No",
  onSubmit: onDelete,
  open: open,
  onClose: onClose,
  submitButtonContent: "Yes",
  text: `If you are sure, type the word DELETE in all caps and click "Yes."`,
  title: "Are you sure you want to delete this? This action cannot be undone.",
  validationSchema: yup.object().shape({
    answer: yup.string().oneOf(['DELETE'], 'You must enter DELETE in all caps.').required('You must enter DELETE in all caps.')
  })
}, props), () => React.createElement(React.Fragment, null, React.createElement(GridContainer, null, React.createElement(LinkedTextInput, {
  autoFocus: true,
  label: "DELETE",
  name: "answer",
  fullWidth: true
})), children));

DeleteDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired
};
export default DeleteDialog;